import { get, isEmpty, isBoolean } from 'lodash';
import { checkIsPastTimestamp } from '../utils';
import PointsPage from './pointsPage';
import PointsHeader from './pointsHeader';
import OfferHeader from './offerHeader';

import views from '../components/views';
import selectors from '../components/selectors';
import Terms from '../components/terms';

import Survey from '../components/survey';
import MoveBack from '../components/moveBack';
import request from '../request';
import SurveyCard from './SurveyCard';

class Offerwall {
  constructor() {
    const container = document.createElement('div');
    this.container = container;
    this.data = [];
  }

  getSurveys() {
    const offerwallSortProperty = Pollfish.helper.getOfferwallSortProperty();
    const offerwallSortOrder = Pollfish.helper.getOfferwallSortOrder();
    const data = {
      sortBy: offerwallSortProperty,
      order: offerwallSortOrder,
    };
    // will be needed again in the future if we need to filter the results
    // const surveyIds = this.data.map((survey) => survey.id) || [];
    this.container.innerHTML = `<div class="container">${Pollfish.ui.getSpinner()}</div>`;
    request({ url: '/v2/device/offerwall/surveys', data })
      .then((payload = {}) => {
        const surveys = payload.surveys || [];
        if (!payload.hasDemographics || surveys.length === 0) {
          // only call these once
          if (!Pollfish.helper.webViewLoadedCalled) {
            Pollfish.mobile.interface.noSurveyFound();
            Pollfish.helper.webViewLoadedCalled = true;
          }
          Pollfish.ui.noSurveyAvailable();
          return;
        }
        // reset noSurveyAvailable flag in case it is false
        Pollfish.helper.noSurveyAvailable = false;
        Pollfish.mobile.interface.webViewLoaded();
        const surveyIds = surveys.map((survey) => survey.id);
        Pollfish.mobile.interface.sendToServer(
          '/v2/device/offerwall/set/surveys/received',
          `{"s_ids": "${surveyIds}"}`,
          false,
        );
        this.data = surveys;
        this.render();
      })
      .catch((e) => {
        Pollfish.helper.handleGlobalPromiseError(e);
        Pollfish.helper.hideSubmitBtn = true; // NOTE (to self): 🤦
        if (Pollfish.helper.isDevelopment()) {
          // eslint-disable-next-line no-console
          console.warn(
            '[Warning]: The dyson mock server seems to be down. Start it using `yarn mock`.',
          ); //eslint-disable-line
        }
      });
  }

  render() {
    if (!this.data) return this.container;
    // sort by superHot first
    this.data.sort((a, b) => b.superHot - a.superHot);
    const surveyContent = this.data.map((survey, index) => {
      const enrichedSurvey = {
        ...survey,
        index,
        listLength: this.data.length,
      };
      return survey.superHot
        ? `
          <div class="margin-sm-btm col-12">
            ${new SurveyCard(enrichedSurvey).render()}
          </div>`
        : `
          <div class="margin-sm-btm col-6 col-xs-12">
            ${new SurveyCard(enrichedSurvey).render()}
          </div>`;
    });
    this.container.innerHTML = `
      <section class="container">
        <div class="flex flex-wrap margin-sm row">
          ${surveyContent.join('')}
        </div>
      </section>
    `;
    return this.container;
  }
}

/* eslint-disable */
const attachEventListeners = (
  container,
  pointsHeader,
  offerHeader,
  offerwall,
) => {
  container.on('tap', '.js-survey-card', function(e) {
    const surveyCard = $(this).closest('.js-survey-card');
    const surveyId = surveyCard.data('id');
    const surveyIndex = surveyCard.data('survey-index');
    const surveysListLength = surveyCard.data('surveys-list-length');
    const surveyNoCheck = surveyCard.data('survey-no-check');
    Pollfish.ui.showSurveyLoading();
    // clear offer header countdown interval since element is not visible
    offerHeader.clearTimer();

    if (!Pollfish.helper.isDebugMode()) {
      Pollfish.analytics.sendMetric({
        metric: 'offerwall-survey-card-click-monitor',
        deviceId: get(Pollfish, 'helper.json.raw.device_id', null),
        surveyId,
        tags: {
          surveyIndex,
          surveysListLength,
        },
      });
    }

    const data = {};
    if (isBoolean(surveyNoCheck)) {
      data.no_check = surveyNoCheck;
    }

    request({ url: `/v2/device/offerwall/surveys/${surveyId}`, data })
      .then((payload) => {
        if (payload.success) {
          Pollfish.ui.unmountReactOfferwallSortingComponent();
          const {
            translations,
            feedback_questions: feedbackQuestions,
            ...survey
          } = { ...payload.data };
          const { lang, hasCustomTerms } = survey;
          Pollfish.helper.addTranslation({
            lang,
            texts: translations,
            feedbackQuestions,
          });
          Pollfish.helper.changeLanguage(lang);

          // we don't need to check the status again since we just received it
          Pollfish.survey = new Survey(survey);

          if (hasCustomTerms) {
            Pollfish.survey.showOfferwallHomescreen();
            Pollfish.mobile.interface.sendToServer(
              '/v2/device/set/survey/viewed',
              `{"s_id": "${surveyId}"}`,
              false,
            );
            return;
          }
          Pollfish.survey.start();
          Pollfish.mobile.interface.sendToServer(
            '/v2/device/set/survey/viewed',
            `{"s_id": "${surveyId}"}`,
            false,
          );
        } else {
          const promptText = Pollfish.ui.getText(
            'offerwall.notifications.survey_closed',
          );
          Pollfish.ui.prompt(promptText);
          // remove survey that had the error
          offerwall.data = offerwall.data.filter(
            (survey) => survey.id !== surveyId,
          );
          container.html('');
          Pollfish.ui.unmountReactOfferwallSortingComponent();
          container.append(pointsHeader.render());
          Pollfish.ui.renderReactOfferwallSortingComponent();
          container.append(offerwall.render());
          $('body').attr('data-page', 'offerwall');
        }
      })
      .catch((e) => {
        const promptText = Pollfish.ui.getText(
          'offerwall.notifications.survey_closed',
        );
        console.log(e);
        Pollfish.ui.prompt(promptText);
        // remove survey that had the error
        offerwall.data = offerwall.data.filter(
          (survey) => survey.id !== surveyId,
        );
        $('body').attr('data-page', 'offerwall');
        container.html('');
        Pollfish.ui.unmountReactOfferwallSortingComponent();
        container.append(pointsHeader.render());
        Pollfish.ui.renderReactOfferwallSortingComponent();
        container.append(offerwall.render());
      });
  });
  /* eslint-enable */

  container.on('click', '.header__action-refresh-btn', () => {
    Pollfish.offerwallPage.getSurveys();
  });
};

const renderTerms = () => {
  const termsOptions = {
    elem: selectors.termsLink,
    moveBackBtn: $(selectors.moveBackBtn),
    currentPage: views.basic.terms,
    mainContent: $(selectors.mainContent),
    prevPage: 'offerwall',
  };
  new Terms(termsOptions).render();
};

// TODO: if this gets called more than once, many events are getting fired all at once.
export default function InitOfferwall() {
  let { pointsPage, offerwallPage, pointsHeader, offerHeader } = Pollfish;

  Pollfish.ui.applyBrandedSurveyStyles();

  if (!offerwallPage || !pointsPage || !offerHeader) {
    offerwallPage = new Offerwall();
    pointsPage = new PointsPage();
    pointsHeader = new PointsHeader(
      Pollfish.ui.getText,
      Pollfish.helper.json.theme,
    );
    offerHeader = new OfferHeader(Pollfish.ui.getText);

    // unfortunately these are necessary since we need to refresh them every time but not
    // change their values
    Pollfish.offerwallPage = offerwallPage;
    Pollfish.pointsPage = pointsPage;
    Pollfish.pointsHeader = pointsHeader;
    Pollfish.offerHeader = offerHeader;
  }

  const mainContent = $(selectors.mainContent);
  pointsHeader.onClick(() => {
    offerHeader.clearTimer();
    mainContent.html('');
    Pollfish.ui.unmountReactOfferwallSortingComponent();
    mainContent.append(pointsHeader.render());
    Pollfish.ui.renderReactOfferwallSortingComponent();
    mainContent.append(pointsPage.render());
    pointsPage.getPoints();
    $('body').attr('data-page', 'points');

    if (!Pollfish.helper.REMOVETHIS) {
      Pollfish.helper.REMOVETHIS = true;
      new MoveBack({
        moveBackBtn: $(selectors.moveBackBtn),
        prevPage: 'offerwall',
      }).render();
    }
  });

  pointsPage.onPointsChange((points, pendingPoints, label) => {
    pointsHeader.update(points, pendingPoints, label);
  });

  pointsPage.getPoints();

  const shouldShowDemographics =
    !Pollfish.demographics.isCompleted() &&
    !isEmpty(Pollfish.helper.json.tag_survey);

  const content = document.createElement('div');
  content.className = 'offerwall-container';

  mainContent.html('');
  Pollfish.ui.unmountReactOfferwallSortingComponent();
  mainContent.append(pointsHeader.render());
  Pollfish.ui.renderReactOfferwallSortingComponent();
  mainContent.append(offerHeader.render());
  // clear offerHeader interval if already exists
  offerHeader.clearTimer();
  // if time schedule offer has not ended yet start countdown
  if (!checkIsPastTimestamp(Pollfish.helper.json.reward_offer_expiration)) {
    offerHeader.startOfferCountdown(() => {
      Pollfish.offerwallPage.getSurveys();
    });
  }

  const lastOfferwallSortProperty = get(
    Pollfish,
    'helper.json.raw.lastOfferwallSortProperty',
  );
  if (lastOfferwallSortProperty) {
    // offerwall sort is missing from SDK mediation redirects
    // and we are grabbing it from a different object on the url
    Pollfish.helper.setOfferwallSortProperty(lastOfferwallSortProperty);
    Pollfish.helper.json.raw.lastOfferwallSortProperty = null;
  }

  const lastSurveyId = get(Pollfish, 'helper.json.raw.lastSurveyId');
  if (lastSurveyId) {
    // needed for figuring out the success/error notifications
    pointsPage.pendingSurveyIds.push(lastSurveyId);
    // session id is missing from SDK mediation redirects
    // and we are grabbing it from a different object on the url
    Pollfish.helper.json.session_id = get(
      Pollfish,
      'helper.json.raw.session_id',
    );
    const surveySessionId = get(Pollfish, 'helper.json.raw.survey_session_id');
    const survey = new Survey({
      s_id: lastSurveyId,
      survey_session_id: surveySessionId,
      isPartialSurvey: true,
    });
    Pollfish.survey = survey;
    Pollfish.helper.handlePreviousSurvey(survey.props.surveyId);
  } else if (shouldShowDemographics) {
    // shows the indicator
    offerHeader.hide();
    Pollfish.mobile.interface.webViewLoaded();
    Pollfish.sanity.setDisqualified(false);
    content.innerHTML = Pollfish.ui.showUnlockScreen();
    mainContent.append(content);
    Pollfish.ui.renderLanguageSelect();
    Pollfish.event.getStarted();
    renderTerms();
  } else {
    $('body').attr('data-page', 'offerwall');
    content.appendChild(offerwallPage.render());
    offerwallPage.getSurveys();
    mainContent.append(content);

    if (!Pollfish.helper.hasAttachedListeners) {
      Pollfish.helper.hasAttachedListeners = true;
      attachEventListeners(
        mainContent,
        pointsHeader,
        offerHeader,
        offerwallPage,
      );
    }
  }

  // send a session started whenever a user interacts with anything on the page
  $(selectors.offerwallContainer).on('click tap', () => {
    Pollfish.mobile.interface.sendToServer(
      '/v2/device/set/session/start',
      '{}',
      false,
    );
    $(selectors.offerwallContainer).off('click tap');
  });
}
